import { Component, OnInit } from '@angular/core';
import { Hotel } from '../hotel';

import { ActivatedRoute, Params, Router} from '@angular/router';

import { HotelService } from '../services/hotel.service';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-addhotel',
  templateUrl: './addhotel.component.html',
  styleUrls: ['./addhotel.component.css']
})
export class AddhotelComponent implements OnInit {

  constructor( private router:Router, private hotelService:HotelService, private messageService:MessageService) { }

  ngOnInit() {
  }

  model = new Hotel();

  addHotel(){
    
    this.hotelService
        .addHotel(this.model)
        .subscribe( response => {
          // console.log(response);
          //console.log("success");
          this.messageService.showMessage('div#msg','alert-info',response.response,'glyphicon-ok')
        })
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/addhotel/addhotel.component.ts